module.exports = ["щойно",["%s секунда тому","%s секунд тому"],["%s хвилина тому","%s хвилин тому"],["%s година тому","%s годин тому"],["%s день тому","%s днів тому"],["%s тиждень тому","%s тижнів тому"],["%s місяць тому","%s місяців тому"],["%s рік тому","%s років тому"]]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/uk-UA.json
// module id = fRYD
// module chunks = 1